<div class="subscriber-main-container">
  <div class="subscriber-cups">
    @if (currentSubscriberCupsList) {
      <app-subscriber-cups
        [cupsList]="currentSubscriberCupsList"
        [cupsData]="currentSubscriberCupsData"
        >
      </app-subscriber-cups>
    }
  </div>
</div>
